export default "__VITE_ASSET__C39Hs$Lr__"